import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import styles from './ErrorPage.module.css';

function ErrorPage() {
    let error = useRouteError();
    let errorMessage;
    let errorStack = null;
    let errorDetails = null;

    // Check if we're in development mode
    const isDevelopment = import.meta.env.NODE_ENV === 'development';

    if (isRouteErrorResponse(error)) {
        // error is type `ErrorResponse`
        console.log('Route response error', error);
        errorMessage = error.error?.message || error.statusText;
        errorStack = error.error?.stack;
        errorDetails = error;
    } else if (error instanceof Error) {
        console.log('Error error', JSON.stringify(error, null, 2));
        errorMessage = error.message || error.error?.message;
        errorStack = error.stack;
        errorDetails = error;
    } else if (typeof error === 'string') {
        console.log('string error', error);
        errorMessage = error;
    } else {
        console.log('Other error', error);
        console.error(error);
        errorMessage = 'Unknown error';
        errorDetails = error;
    }

    return (
    <>
    <div className={styles.root}>
        <h2>Oops, looks like something went wrong.</h2>
        <p>{errorMessage}</p>
        
        {isDevelopment && (
            <div className={styles.debugInfo}>
                {errorStack && (
                    <>
                        <h3>Stack Trace:</h3>
                        <pre className={styles.stack}>{errorStack}</pre>
                    </>
                )}
                
                {errorDetails && (
                    <>
                        <h3>Error Details:</h3>
                        <pre className={styles.stack}>{JSON.stringify(errorDetails, null, 2)}</pre>
                    </>
                )}
            </div>
        )}
    </div>
    </>
    );
 }

 export default ErrorPage;